export default __webpack_public_path__ + "static/media/facebook.d76bbba2.svg";